import {Pipe, PipeTransform} from '@angular/core';

/*
 * Replace null value
*/
@Pipe({name: 'ifNull'})
export class IfNullPipe implements PipeTransform {
  transform(value: string, replace: string): string {
    if (value) {
      return value;
    } else {
      return replace;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/main.pipe.ts